import { typeSafeAssign } from '@/utils/common'
import { makeObservable, observable } from 'mobx'
import { EMPTY_NUMBER_ID } from 'src/constant/common'
import { UndoableDTO } from 'src/dto/UndoableDTO'

export class ProblemScoringExam extends UndoableDTO {
  examProblemId: number = EMPTY_NUMBER_ID
  result: common.ScoringResult = 'CORRECT'
  score: number = 0

  constructor(data: res.GroupStudentExamResult['scoringList'][number]) {
    super()
    makeObservable(this, {
      examProblemId: observable,
      result: observable,
      score: observable,
    })

    if (data) typeSafeAssign(this, data)
  }
}
